import { getJSON } from 'common/services/api'
import { Spinner } from 'components/generic'
import type { FC } from 'react'
import { useQueryClient } from 'react-query'
import {
  AppStepCard,
  CarePlansStepCard,
  GreatJobStepCard,
  LogsStepCard,
  RiskAssesmentsStepCard,
  StartStepCard
} from './steps'

type Props = {
  carerId: string
  exampleResidentId?: string
  step?: number
  qrCode?: string
  url?: string
}

export const OnboardingCard: FC<Props> = ({
  carerId,
  exampleResidentId,
  step,
  qrCode,
  url
}) => {
  const queryClient = useQueryClient()

  if (!step && step !== 0) {
    return <Spinner />
  }

  const handleIncrement = () => {
    getJSON({
      url: `/api/list/carers/${carerId}/intro-steps?increment=true`
    }).then(() => {
      handleNext()
    })
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleNext = () => {
    queryClient.invalidateQueries('step-intro')
  }

  const steps = [
    <StartStepCard onClick={handleIncrement} />,
    <CarePlansStepCard exampleResidentId={exampleResidentId} />,
    <RiskAssesmentsStepCard exampleResidentId={exampleResidentId} />,
    <LogsStepCard />,
    <AppStepCard qrCode={qrCode} url={url} />,
    <GreatJobStepCard onClick={handleIncrement} />
  ]

  return steps[step]
}
